import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { DashBoardAgencias, Registro, Admin } from '../pages'
import Login from '../pages/Login/Login'
import Marketplace from '../pages/Marketplace/Marketplace'

import { PrivateAgencia } from './PrivateAgencia'
import { PrivateAdmin } from './PrivateAdmin'
import { PrivateUsuario } from './PrivateUsuario'
import { Private } from './Private'
import { PrivateUsuarioNoRegistrado } from './PrivateUsuarioNoRegistrado'

import { PerfilAgencia } from '../pages/PerfilAgencia/PerfilAgencia'
import { CarritoCompra } from '../pages/carritoCompra/CarritoCompra'
import { HistorialCuidados } from '../pages/historialCuidados/HistorialCuidados'
import { DashBoardUsuarios } from '../pages/dashBoardUsuarios/DashBoardUsuarios'
import { MonitorCuidados } from '../pages/monitorCuidados/MonitorCuidados'
import { ReservarServicio } from '../pages/ResevarServicio/ReservarServicio'
import { ServiciosOfrecidos } from '../pages/serviciosOfrecidos/ServiciosOfrecidos'
import { Notificaciones } from '../pages/noTificaciones/Notificaciones'
import { Mensajes } from '../pages/mensajes/Mensajes'
import { MiPerfil } from '../pages/miPerfil/MiPerfil'
import { Presupuestos } from '../pages/Presupuestos/Presupuestos'
import { HistorialFacuturas } from '../pages/HistorialFacturas/HistorialFacuturas'
import { UserFeedback } from '../pages/UserFeedback/UserFeedback'
import { Pacientes } from '../pages/Pacientes/Pacientes'
import { Usuarios } from '../pages/Usuarios/Usuarios'
import { Cuidadores } from '../pages/Cuidadores/Cuidadores'
import { Graficas } from '../pages/Graficas/Graficas'
import { Empresas } from '../pages/Empresas/Empresas'
import { GenerarDocumentos } from '../pages/GenerarDocumentos/GenerarDocumentos'
import { SolicitarCambios } from '../pages/SolicitarCambios/SolicitarCambios'
import { MiEmpresa } from '../pages/miEmpresa/MiEmpresa'
import { OlvContraseña } from '../pages/Contraseña/OlvContraseña'
import { MisPacientes } from '../pages/MisPacientes/MisPacientes'
import { Encuestas } from '../pages/Encuestas/Encuestas'
import { LoginAdmin } from '../pages/LoginAdmin'
import { CategoriasServicios } from '../pages/CategoriasSevicios/CategoriasServicios'
import RegistroEmpresas from '../pages/RegistroEmpresas/RegistroEmpresas'
import LoginEmpresa from '../pages/LoginEmpresa/LoginEmpresa'
/*import { Calendario } from '../pages/CalendarioEmpresa/Calendario'*/
import { Documentos } from '../pages/Documentos/Documentos'
import { CategoriasEmpresa } from '../pages/CategoriasEmpresa/CategoriasEmpresa'
import logoCuidatia from './logoCuidatia5.png'
import { PrivateUsuarioAndNoRegitrado } from './PrivateUsuarioAndNoRegitrado'
import { ErrorNoFound } from '../pages/404/ErrorNoFound'

import { PoliticaCookies } from '../pages/PoliticaCookies/PoliticaCookies'
import { AvisoLegal } from '../pages/AvisoLegal/AvisoLegal'
import { PoliticaPrivacidad } from '../pages/PoliticaPrivacidad/PoliticaPrivacidad'
import { PreguntasFrecuentes } from '../pages/PreguntasFrecuentes/PreguntasFrecuentes'
import { ClubCuidatia } from '../pages/ClubCuidatia/ClubCuidatia'

import { CafeRural } from '../pages/CafeRural/CafeRural'

import { SobreNosotros } from '../pages/SobreNosotros/SobreNosotros'

import { Home } from '../pages/Home/Home'
import { Valoraciones } from '../pages/Valoraciones/valoraciones'
import { Calendario } from '../pages/CalendarioEmpresa/Calendario'
import Calendarios from '../pages/Calendario/Calendarios'
import MiClub from '../pages/ClubCuidatia/miClub'
import SuccessPage from '../pages/success'
import {Soporte} from '../pages/Soporte/Soporte'
import { SingUp } from '../pages/SingUp/SingUp'


/* The above code is creating a route for each page of the application. */
export const AppRouter = (props) => {

    /* A hook that is executed when the component is mounted. */

    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path='/404' element={
                        <ErrorNoFound />
                    } />
                    <Route path="*" element={
                        <ErrorNoFound />
                    } />

                    <Route path='/un-cafe-rural' element={
                        <CafeRural />
                    } />



                    <Route path='/sobre-nosotros' element={
                        <SobreNosotros />
                    } />

                    <Route path='/busqueda' element={
                        <PrivateUsuarioAndNoRegitrado>
                            <Marketplace />
                        </PrivateUsuarioAndNoRegitrado>
                    } />
                    <Route path='/olvidarContrasena' element={
                        <PrivateUsuarioNoRegistrado>
                            <OlvContraseña />
                        </PrivateUsuarioNoRegistrado>
                    } />
                    <Route path='/login/:goTo?' element={
                        <PrivateUsuarioNoRegistrado>
                            <Login />
                        </PrivateUsuarioNoRegistrado>
                    } />
                    <Route path='/loginEmpresa' element={
                        <PrivateUsuarioNoRegistrado>
                            <LoginEmpresa />
                        </PrivateUsuarioNoRegistrado>
                    } />
                    <Route path='/loginAdmin' element={
                        <PrivateUsuarioNoRegistrado>
                            <LoginAdmin />
                        </PrivateUsuarioNoRegistrado>
                    } />
                    <Route path='/misPacientes/:goTo?' element={
                        <PrivateUsuario>
                            <MisPacientes />
                        </PrivateUsuario>
                    } />
                    <Route path='/perfilAgencia/:id' element={
                        <PrivateUsuarioAndNoRegitrado>
                            <PerfilAgencia />
                        </PrivateUsuarioAndNoRegitrado>
                    } />
                    <Route path='/carrito' element={
                        <PrivateUsuario>
                            <CarritoCompra />
                        </PrivateUsuario>
                    } />
                    {/* 
                    <Route path='/reservaServicio' element={
                        <PrivateUsuario>
                            <ReservarServicio />
                        </PrivateUsuario>
                    } />
                    <Route path='/miDashboard' element={
                        <PrivateUsuario>
                            <DashBoardUsuarios />
                        </PrivateUsuario>
                    } />
                    <Route path='/historialCuidados' element={
                        <PrivateUsuario>
                            <HistorialCuidados />
                        </PrivateUsuario>
                    } />
                    <Route path='/solicitarCambios' element={
                        <PrivateUsuario>
                            <SolicitarCambios />
                        </PrivateUsuario>
                    } />
                    */}
                    <Route path='/monitorCuidados' element={
                        <PrivateUsuario>
                            <MonitorCuidados />
                        </PrivateUsuario>
                    } />

                    <Route path='/serviciosOfrecidos' element={
                        <PrivateUsuario>
                            <ServiciosOfrecidos />
                        </PrivateUsuario>
                    } />
                    <Route path='/notificaciones' element={
                        <Private>
                            <Notificaciones />
                        </Private>
                    } />
                    <Route path='/mensajes' element={
                        <Private>
                            <Mensajes />
                        </Private>
                    } />
                    <Route path='/presupuestos' element={
                        <PrivateAgencia>
                            <Presupuestos />
                        </PrivateAgencia>
                    } />
                    <Route path='/misDocumentos' element={
                        <PrivateAgencia>
                            <Documentos />
                        </PrivateAgencia>
                    } />
                    <Route path='/misCategorias' element={
                        <PrivateAgencia>
                            <CategoriasEmpresa />
                        </PrivateAgencia>
                    } />
                    <Route path='/historialFacturas' element={
                        <PrivateAgencia>
                            <HistorialFacuturas />
                        </PrivateAgencia>
                    } />
                    <Route path='/miPerfil' element={
                        <PrivateUsuario>
                            <MiPerfil />
                        </PrivateUsuario>
                    } />
                    <Route path='/registro' element={
                        <PrivateUsuarioNoRegistrado>
                            <SingUp />
                        </PrivateUsuarioNoRegistrado>
                    } />

                    <Route path='/registro/cliente' element={
                        <PrivateUsuarioNoRegistrado>
                            <Registro />
                        </PrivateUsuarioNoRegistrado>
                    } />

                    <Route path='/registro/profesional' element={
                        <PrivateUsuarioAndNoRegitrado>
                            <RegistroEmpresas />
                        </PrivateUsuarioAndNoRegitrado>
                    } />
                    <Route path='/pacientes' element={
                        <PrivateAdmin>
                            <Pacientes />
                        </PrivateAdmin>
                    } />
                    <Route path='/usuarios' element={
                        <PrivateAdmin>
                            <Usuarios />
                        </PrivateAdmin>
                    } />

                    <Route path='/cuidadores' element={
                        <PrivateAgencia>
                            <Cuidadores />
                        </PrivateAgencia>
                    } />
                    <Route path='/userFeedback' element={
                        <PrivateAgencia>
                            <UserFeedback />
                        </PrivateAgencia>
                    } />
                    <Route path='/graficas' element={
                        <PrivateAdmin>
                            <Graficas />
                        </PrivateAdmin>
                    } />
                    <Route path='/generarInformes' element={
                        <PrivateAgencia>
                            <GenerarDocumentos />
                        </PrivateAgencia>
                    } />
                    <Route path='/agencia' element={
                        <PrivateAgencia>
                            <DashBoardAgencias />
                        </PrivateAgencia>
                    } />
                    <Route path='/admin' element={
                        <PrivateAdmin>
                            <Admin />
                        </PrivateAdmin>
                    }
                    />
                    <Route path='categoriasServicios' element={
                        <PrivateAdmin>
                            <CategoriasServicios />
                        </PrivateAdmin>
                    } />
                    <Route path='Empresas' element={
                        <PrivateAdmin>
                            <Empresas />
                        </PrivateAdmin>
                    } />
                    <Route path='/encuestas' element={
                        <PrivateUsuario>
                            <Encuestas />
                        </PrivateUsuario>
                    } />
                    <Route path='/miEmpresa' element={
                        <PrivateAgencia>
                            <MiEmpresa />
                        </PrivateAgencia>
                    } />
                    <Route path='/calendario' element={
                        <PrivateAgencia>
                            <Calendario />
                        </PrivateAgencia>
                    } />
                    <Route path='/logoCuidatia' element={
                        <img src={logoCuidatia} alt='logo-cuidatia' />
                    } />
                    <Route path='/politica-privacidad' element={
                        <PoliticaPrivacidad />
                    } />
                    <Route path='/politica-cookies' element={
                        <PoliticaCookies />
                    } />
                    <Route path='/aviso-legal' element={
                        <AvisoLegal />
                    } />
                    <Route path='/preguntas-frecuentes' element={
                        <PreguntasFrecuentes />
                    } />
                    <Route path='/club-cuidatia' element={
                        <ClubCuidatia />
                    } />

                    <Route path='/resenas' element={
                        <Valoraciones />
                    } />

                    <Route path='/calendarios' element={
                        <PrivateAgencia>
                            <Calendarios />
                        </PrivateAgencia>
                    }/>

                    <Route path='/miPlan' element={
                        <PrivateAgencia>
                            <MiClub />
                        </PrivateAgencia>
                    }/>

                    <Route path='/' element={
                        <Home />
                    } />

                    <Route path='/success' element={
                        <PrivateAgencia>
                            <SuccessPage />
                        </PrivateAgencia>
                    } />

                    <Route path='/soporte' element={
                        <Soporte />
                    } />

                </Routes>
            </BrowserRouter>
        </>
    )
}
